import { CONFIG } from 'src/config/envConstants';
import keycloak from 'src/Keycloak';
import { normalizeVoiceModelId } from 'src/views/table/aiVoiceModels';

/**
 * @param {Blob} audioBlob
 * @param {string} [modelId] e.g. gemini-2.5-pro | gpt-4o-transcribe
 */
export async function postVoicePreview(audioBlob, modelId) {
  const base = (CONFIG.REACT_APP_IA_DATA_COLLECTOR_API_BASE_URL || '').replace(/\/$/, '');
  if (!base) {
    return Promise.reject(new Error('Data collector API base URL is not configured.'));
  }

  const formData = new FormData();
  const fileName =
    audioBlob.type?.includes('mp4') ? 'recording.m4a' : 'recording.webm';
  formData.append('audio', audioBlob, fileName);
  const apiModel = normalizeVoiceModelId(modelId);
  if (apiModel) {
    formData.append('model', apiModel);
  }

  const headers = {};
  if (keycloak?.token) {
    headers.Authorization = `Bearer ${keycloak.token}`;
  }

  const res = await fetch(`${base}/api/process`, {
    method: 'POST',
    body: formData,
    headers,
  });

  const data = await res.json().catch((e) => ({
    error: e.message
  }));

  if (!res.ok) {
    const msg = data.error;
    throw new Error(typeof msg === 'string' ? msg : 'Voice preview failed');
  }

  return data;
}
